import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Ai\ChatApprovalController::__invoke
* @see app/Http/Controllers/Ai/ChatApprovalController.php
* @route '/api/ai/chat/approvals'
*/
const ChatApprovalController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChatApprovalController.url(options),
    method: 'post',
})

ChatApprovalController.definition = {
    methods: ["post"],
    url: '/api/ai/chat/approvals',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Ai\ChatApprovalController::__invoke
* @see app/Http/Controllers/Ai/ChatApprovalController.php
* @route '/api/ai/chat/approvals'
*/
ChatApprovalController.url = (options?: RouteQueryOptions) => {
    return ChatApprovalController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Ai\ChatApprovalController::__invoke
* @see app/Http/Controllers/Ai/ChatApprovalController.php
* @route '/api/ai/chat/approvals'
*/
ChatApprovalController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChatApprovalController.url(options),
    method: 'post',
})

export default ChatApprovalController